import type { PropsWithChildren } from "react";

import { TippyV2 as Tippy } from "@/react/components/SettingsApp/CompassCompat/Tooltip";

interface TitleItemProps {
  title?: string;
}

export const TitleItem = ({
  children,
  title,
}: PropsWithChildren<TitleItemProps>) => (
  <div>
    {children}
    {title && (
      <span className="flex w-full min-w-0">
        <Tippy content={title} className="truncate text-lg font-semibold">
          {title}
        </Tippy>
      </span>
    )}
  </div>
);
